module.exports = __webpack_public_path__ + "img/badge.6370dc19.png";